<template>
    <div>
      <el-row class="breadcrumb">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item
            v-for="(item,index) in $store.state.navigation.breadcrumbmenu"
            :key="index"
          >
            <a href="javascript:;">{{item.name}}</a>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </el-row>
    </div>
</template>

<script>

export default {
    computed: {

    },


    mounted() {

    }
}
</script>



// WEBPACK FOOTER //
// src/js/containers/Breadcrumb.vue